import React from "react";
import * as dateFns from "date-fns";
import CalendarCell from "./Calendar.cell";

class CustomCalendar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentMonth: this.props.currentMonth,
      attendance: this.props.attendance,
      currentSemester: this.props.currentSemester,
      modalAttendanceHasChanged: this.props.modalAttendanceHasChanged,
    };
  }

  renderHeader() {
    const dateFormat = "MMMM yyyy";

    return (
      <div className="header row flex-middle">
        <div className="col col-center">
          <span>{dateFns.format(this.props.currentMonth, dateFormat)}</span>
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    let currentMonth = nextProps.currentMonth;
    let currentSemester = nextProps.currentSemester;
    let attendance = nextProps.attendance;
    let modalAttendanceHasChanged = nextProps.modalAttendanceHasChanged;

    attendance = JSON.parse(JSON.stringify(attendance));

    this.setState({
      currentMonth: currentMonth,
      attendance: attendance,
      currentSemester: currentSemester,
      modalAttendanceHasChanged: modalAttendanceHasChanged,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      dateFns.format(this.state.currentMonth, "MMddyyyy") !==
        dateFns.format(nextProps.currentMonth, "MMddyyyy") ||
      this.state.attendance.length !== nextProps.attendance.length ||
      this.state.currentSemester !== nextProps.currentSemester ||
      this.state.modalAttendanceHasChanged !==
        nextProps.modalAttendanceHasChanged
    );
  }

  renderDays() {
    const dateFormat = "iii";
    const days = [];

    let startDate = dateFns.startOfWeek(this.props.currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          {dateFns.format(dateFns.addDays(startDate, i), dateFormat)}
        </div>
      );
    }

    return <div className="days row">{days}</div>;
  }

  isHoliday(date) {
    return this.props.tables.holidays.find(
      (x) => x.date === dateFns.format(date, "yyyy-MM-dd") + "T00:00:00"
    );
  }

  renderCells() {
    const monthStart = dateFns.startOfMonth(this.props.currentMonth);
    const monthEnd = dateFns.endOfMonth(monthStart);
    const startDate = dateFns.startOfWeek(monthStart);
    const endDate = dateFns.endOfWeek(monthEnd);

    const dateFormat = "d";
    const rows = [];

    let days = [];
    let day = startDate;
    let formattedDate = "";

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = dateFns.format(day, dateFormat);

        let attendancesOnDay = this.getAttendanceOnDay(day);

        let isHoliday = this.isHoliday(day);
        let leftNote = "";
        let rightNote = "";

        let disabled =
          !dateFns.isSameMonth(day, monthStart) ||
          day < dateFns.parseISO(this.props.currentSemester.startDate) ||
          day > dateFns.parseISO(this.props.currentSemester.endDate) ||
          dateFns.isWeekend(day) ||
          dateFns.isFriday(day) ||
          isHoliday
            ? " disabled"
            : "";

        let attendancesOnDayRender = attendancesOnDay.map((a, y) => {
          return (
            <CalendarCell
              key={y}
              day={day}
              monthStart={monthStart}
              leftPosition={
                ((y + 1) * 100) / (attendancesOnDay.length + 1) + "%"
              }
              attendance={a}
              onClick={this.props.onClick}
            ></CalendarCell>
          );
        });

        days.push(
          <div
            id="divCalendar"
            className={`col cell ${disabled} ${leftNote} ${rightNote}`}
            key={day}
          >
            <span className="number">{formattedDate}</span>

            {attendancesOnDayRender}
          </div>
        );

        day = dateFns.addDays(day, 1);
      }

      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );

      days = [];
    }

    return <div className="body">{rows}</div>;
  }

  getAttendanceOnDay(day) {
    return this.props.attendance
      .filter((x) => x.date === dateFns.format(day, "MM/dd/yyyy"))
      .sort((a, b) => {
        const timeA = a.Start.split(":").reduce(
          (acc, time, index) => acc + parseInt(time) * Math.pow(60, 2 - index),
          0
        );
        const timeB = b.Start.split(":").reduce(
          (acc, time, index) => acc + parseInt(time) * Math.pow(60, 2 - index),
          0
        );
        return timeA - timeB;
      });
  }

  render() {
    return (
      <React.Fragment>
        <div className="calendar">
          {this.renderHeader()}
          {this.renderDays()}
          {this.renderCells()}
        </div>
      </React.Fragment>
    );
  }
}

export default CustomCalendar;
